import { Component, Input } from '@angular/core';
import { Unpaid, UnpaidStatus } from 'src/app/core/unpaid.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-order-details-installments-unpaids',
  templateUrl: './order-details-installments-unpaids.component.html',
  styleUrls: ['./order-details-installments-unpaids.component.scss'],
})
export class OrderDetailsInstallmentsUnpaidsComponent {
  @Input() unpaids?: Unpaid[];

  constructor(private utils_service: UtilsService) {}

  getSortedUnpaid(): Unpaid[] {
    if (!this.unpaids) {
      return [];
    }
    return [...this.unpaids].sort((a, b) => {
      const index_a = a.step_index ?? Infinity;
      const index_b = b.step_index ?? Infinity;

      return index_a - index_b;
    });
  }

  getCurrencyLabel(unpaid: Unpaid): string {
    if (unpaid.order_currency) {
      return this.utils_service.getCurrencyLabelFromString(unpaid.order_currency);
    } else {
      return '€';
    }
  }

  getStepStatusClass(status?: UnpaidStatus): string {
    if (status) {
      return this.utils_service.getUnpaidStatusClass(status);
    } else {
      return '';
    }
  }

  getStepStatusLabel(status?: UnpaidStatus): string {
    return this.utils_service.getUnpaidStatusLabel(status);
  }
}
